import React from 'react';
import { Card, Flex, Typography, Button, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import LazyLoad from 'react-lazy-load';
import { CoffeeOutlined } from '@ant-design/icons';
import restaurantSelector from '../../redux/selectors/restaurantSelector';
import tacosImg from '../../assets/text/tacos.webp';
import { getBranchById, getMenuUrl } from '../../utils/branches';

import './UsersText.css';

function UsersText() {
  const { number } = useSelector(restaurantSelector);
  const branch = getBranchById(number);

  return (
    <Flex justify="center" className="users-text-container">
      <Flex className="container limited-width" vertical>
        <Typography.Title level={2} className="users-text-title">
          {`Bienvenido a Taquito Grill: El Mejor Restaurante de Tacos en ${branch.name}`}
        </Typography.Title>

        {branch.hasBreakfast && (
          <Card className="breakfast-highlight-card">
            <Flex align="center" gap="large" wrap>
              <CoffeeOutlined className="breakfast-icon" />
              <Flex vertical flex={1}>
                <Typography.Title level={4} className="breakfast-highlight-title">
                  ¡Nuevos Desayunos Disponibles!
                </Typography.Title>
                <Typography.Text className="breakfast-highlight-text">
                  Comienza tu día con nuestros deliciosos desayunos. Disponibles de 8:00 am a 12:00 pm.
                </Typography.Text>
              </Flex>
              <Button
                type="primary"
                className="breakfast-cta-btn"
                href="#desayunos"
              >
                Ver Desayunos
              </Button>
            </Flex>
          </Card>
        )}
        <Row gutter={[24, 24]} className="container-sections">
          <Col xs={24} lg={12}>
            <Card className="section-card modern-card" style={{ height: '100%' }}>
              <Typography.Title level={4} className="section-title">Descubre nuestros exquisitos tacos</Typography.Title>
              <Flex vertical>
                <Typography.Paragraph>
                  Nuestros tacos son el alma de Taquito Grill.
                </Typography.Paragraph>
                <Typography.Paragraph>
                  Desde los clásicos tacos de carne asada hasta los populares tacos al pastor,
                  cada bocado está lleno de sabor y calidad.
                </Typography.Paragraph>
                <Typography.Paragraph>
                  Utilizamos solo los mejores ingredientes para asegurarnos de que cada taco sea
                  una experiencia inolvidable. ¿Buscas los mejores tacos en
                  {' '}
                  {branch.name}
                  ? No busques más, en Taquito Grill encontrarás lo que necesitas.
                </Typography.Paragraph>
                <Flex justify="center">
                  <LazyLoad>
                    <img src={tacosImg} alt="Imagen de tacos" className="users-text-img" loading="lazy" />
                  </LazyLoad>
                </Flex>
              </Flex>
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card className="section-card modern-card" style={{ height: '100%' }}>
              <Flex vertical>
                <Typography.Title level={4} className="section-title">Un menú para todos los gustos</Typography.Title>
                <Flex vertical>
                  <Typography.Paragraph className="mb-0">
                    En
                    {' '}
                    <strong>Taquito Grill</strong>
                    , nos especializamos en ofrecer una amplia variedad de platos para satisfacer todos los gustos. Nuestro menú incluye:
                  </Typography.Paragraph>
                  <ul className="menu-list">
                    {branch.hasBreakfast && (
                      <li className="menu-list-item">
                        <strong>Desayunos:</strong>
                        {' '}
                        Comienza tu día con nuestros deliciosos desayunos de 8:00 am a 12:00 pm.
                      </li>
                    )}
                    <li className="menu-list-item">
                      <strong>Cortes de carne:</strong>
                      {' '}
                      Disfruta de nuestros selectos cortes de carne preparados a la perfección.
                    </li>
                    <li className="menu-list-item">
                      <strong>Hamburguesas:</strong>
                      {' '}
                      Jugosas y sabrosas, nuestras hamburguesas son una delicia.
                    </li>
                    <li className="menu-list-item">
                      <strong>Ensaladas frescas:</strong>
                      {' '}
                      Perfectas para quienes prefieren opciones más ligeras.
                    </li>
                    <li className="menu-list-item">
                      <strong>Menú infantil:</strong>
                      {' '}
                      Opciones deliciosas y nutritivas para los más pequeños.
                    </li>
                    <li className="menu-list-item">
                      <strong>Postres deliciosos:</strong>
                      {' '}
                      Endulza tu paladar con nuestra selección de postres.
                    </li>
                  </ul>
                </Flex>
                <Flex vertical align="center">
                  <Typography.Text className="menu-description">
                    Conoce nuestro menú completo:
                  </Typography.Text>
                  <Button
                    type="primary"
                    size="large"
                    className="menu-cta-btn"
                    onClick={() => window.open(getMenuUrl(branch), '_blank')}
                  >
                    Ver Menú Completo
                  </Button>
                </Flex>
              </Flex>
            </Card>
          </Col>
        </Row>

      </Flex>
    </Flex>
  );
}

export default UsersText;
